export default "__VITE_ASSET__18NM3reY__"